import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('NEXUS Error Boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-screen bg-[var(--nexus-bg-base)]">
          <div className="nexus-card p-8 max-w-md text-center">
            <AlertTriangle size={48} className="text-[var(--nexus-warning)] mx-auto mb-4" />
            <h2 className="font-heading text-lg font-semibold text-[var(--nexus-text-primary)] mb-2">Something went wrong</h2>
            <p className="text-sm text-[var(--nexus-text-muted)] mb-4">{this.state.error?.message || 'An unexpected error occurred'}</p>
            <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
              className="flex items-center gap-2 mx-auto px-4 py-2 rounded-lg bg-[var(--nexus-primary-bright)] text-white text-sm font-medium">
              <RefreshCw size={14} /> Reload Application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
